import { render } from "./WorldsModule.vue?vue&type=template&id=207b9ed4"
const script = {}
script.render = render

export default script